var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-title-page p-t-40 p-b-50 flex-col-c-m",style:(_vm.imgLink())},[_c('h2',{staticClass:"l-text2 t-center"},[_vm._v(" "+_vm._s(this.$router.currentRoute.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }